/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  FaAngleDoubleRight,
  FaArrowRight,
  FaCheckCircle,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const JumpStartArea = () => {
  const [showMeetings, setShowMeetings] = useState(false);

  useEffect(() => {
    if (!showMeetings) return;
    
    // Load the HubSpot Meetings script if not already loaded
    const existingScript = document.querySelector('script[data-hs-meetings]');
    
    if (!existingScript) {
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src = "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
      s.setAttribute('data-hs-meetings', 'true');
      s.onload = () => {
        // Reinitialize HubSpot embeds after script loads
        if (window.HubSpotConversations) {
          window.HubSpotConversations.widget.refresh();
        }
      };
      document.body.appendChild(s);
    } else {
      // Script already loaded, just refresh the embed
      setTimeout(() => {
        if (window.HubSpotConversations) {
          window.HubSpotConversations.widget.refresh();
        }
      }, 100);
    }
  }, [showMeetings]);
   const outcomes = [
    "Exactly how much to raise",
    "From whom",
    "In what order",
    "And what to fix before you start",
  ];

  const forWho = [
    "Early-stage startups preparing for their first raise",
    "Founders confused between grants vs investors",
    "Companies tired of “pitch-deck-only” advice",
    "Teams rejected by grants or investors without clear reasons",
    "Businesses that want clarity before spending more money",
  ];

  const problem = [
    "The funding strategy is unclear",
    "Grants and investors are pursued in the wrong order",
    "Corporate structure creates red flags",
    "Pitch materials don’t match investor expectations",
    "Time is wasted on low-probability opportunities",
  ];

  const deliverablesLeft = [
    "12–18 month funding roadmap (grants + investors)",
    "Cap table & dilution review",
    "Corporate & compliance readiness audit",
    "Grant eligibility matrix (Eligible / Not Eligible / Watchlist)",
    "Curated investor list (30–40 relevant targets)",
    "Investor readiness gap analysis",
  ];

  const deliverablesRight = [
    "Pitch deck review & optimization notes",
    "Data room structure & templates",
    "90-day funding & application calendar",
    "Investor email & executive summary templates",
    "Two recorded strategy calls",
    "Everything is usable immediately.",
  ];

  const whyChoose = [
    "We focus on fundability — not just fundraising",
    "We combine grants + equity strategically",
    "We fix structure before you pitch",
    "We reduce dilution and wasted effort",
    "We give you clarity before execution",
  ];

  const notIncluded = [
    "Grant writing or submissions",
    "Legal or accounting services",
    "Guaranteed funding outcomes",
  ];

  const afterProgram = [
    "A clear funding strategy",
    "Reduced dilution risk",
    "Grant and investor readiness",
    "Structured execution plan",
    "Confidence to move forward",
  ];

  return (
    <>
      {/* ===================== Service Details Area start ===================== */}
      <div className="service-area  pd-bottom-90 jumpstart-page">
        <div className="container">
          <div className="row">
            {/* LEFT SIDEBAR */}
            <div className="col-lg-4 col-12 order-2 order-lg-1">
              <div className="td-sidebar service-sidebar">
                <div className="widget widget_catagory">
                  <h5 className="widget-title" style={{ color: '#50af9b', cursor: 'pointer', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#50af9b'}>
                    <FaArrowRight />Funding Program
                  </h5>
                  <ul className="catagory-items">
                    <li><Link to="/funding/jumpstart" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Jumpstart</Link></li>
                    <li><Link to="/funding/boost" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Boost</Link></li>
                    <li><Link to="/funding/advisory" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Advisory</Link></li>
                  </ul>

                  <div style={{ height: '16px' }}></div>
                  <h5 className="widget-title" style={{ color: '#50af9b', cursor: 'pointer', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#50af9b'}>
                    <FaArrowRight />Dev Accelerator
                  </h5>
                  <ul className="catagory-items">
                    <li><Link to="/accelerator/dev-sprint" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Sprint</Link></li>
                    <li><Link to="/accelerator/dev-build" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Build</Link></li> 
                    <li><Link to="/accelerator/dev-scale" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Scale</Link></li>
                  </ul>
                </div>

                <div className="widget widget_author text-center">
              
                  <div className="details">
                    {/* Toggle HubSpot Meetings embed when clicked */}
                    <button
                      type="button"
                      className="btn btn-base-color border-radius-5 d-flex align-items-center"
                      onClick={() => setShowMeetings((s) => !s)}
                    >
                      📅  Book a Free Funding Readiness Call +
                    </button>

                    {/* Render embed container when toggled on */}
                    {showMeetings && (
                      <div className="mt-3">
                        <div
                          className="meetings-iframe-container"
                          data-src="https://meetings.hubspot.com/mike-qureshi?embed=true"
                        ></div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="widget widget_download">
                  <h5 className="widget-title" style={{ color: '#50af9b', cursor: 'pointer', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#50af9b'}>
                    <FaArrowRight /> Download
                  </h5>
                  <ul>
                    {/* <li>
                      <a 
                        href="/downloads/sample-funding-roadmap.pdf"
                        style={{ color: '#000000' }}
                        onMouseEnter={(e) => e.target.style.color = '#50af9b'}
                        onMouseLeave={(e) => e.target.style.color = '#000000'}
                      >
                        Download a Sample Funding Roadmap <FaAngleDoubleRight />
                      </a>
                    </li> */}
                    <li>
                      <a 
                        href="/assets/pdf/Evolvelab_Fund_Jumpstart.pdf"
                        style={{ color: '#000000' }}
                        onMouseEnter={(e) => e.target.style.color = '#50af9b'}
                        onMouseLeave={(e) => e.target.style.color = '#000000'}
                      >
                        Download the Program Overview <FaAngleDoubleRight style={{ background: 'rgba(170, 237, 222, 1)'}}onMouseEnter={(e) => e.target.style.background = '#50af9b'}
                        onMouseLeave={(e) => e.target.style.background = 'rgba(170, 237, 222, 1)'} />
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="widget widget_download">
                  <h5 className="widget-title" style={{ color: '#50af9b', cursor: 'pointer', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#50af9b'}>
                    <FaArrowRight /> Jumpstart Snapshot
                  </h5>
                  <ul>
                    <li><a href="#pricing" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'} >Fixed Fee: CAD $2,500 </a></li>
                    <li><a href="#pricing" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Timeline: 30 days </a></li>
                    <li><a href="#pricing" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Equity: None </a></li>
                    <li><a href="#pricing" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Success Fees: None </a></li>
                  </ul>
                </div>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-lg-8 order-1 order-lg-2">
              <div className="blog-details-page-content">
                <div className="single-blog-inner mb-0">
                  {/* HERO IMAGE with VIDEO BACKGROUND */}
                  <div className="thumb" style={{ position: 'relative', overflow: 'hidden', minHeight: '400px', margin: 0 }}>
                    <video
                      autoPlay
                      muted
                      loop
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        zIndex: 0
                      }}
                    >
                      <source src="/assets/video/funding.mp4" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                  <div className="details" style={{ position: 'relative', zIndex: 1, padding: '50px' }}>
                    {/* HERO COPY */}
                    <p className="mb-2" style={{ fontSize: '1.75rem', fontWeight: 700 }}>Evolvelab Fund Jumpstart</p>
                    <h1>Become Truly Fundable — In 30 Days</h1>

                    <p className="mb-2">
                      Stop guessing how to raise capital.
                      <br />
                      Start executing a clear funding plan.
                    </p>

                    <p>
                      Evolvelab Fund Jumpstart is a 30-day, turnkey Funding-as-a-Service engagement designed to make your
                      business grant-ready, investor-ready, and capital-confident — without equity, success fees, or confusion.
                    </p>

                    {/* KEY OUTCOME LIST */}
                    <h5 className="mt-4">By the end of 30 days, you will know:</h5>
                    <ul className="single-list-inner style-check style-check mb-4">
                      {outcomes.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: '#50af9b' }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* PRIMARY CTA ROW */}
                    {/* <div className="d-flex flex-wrap gap-2 mb-4">
                      <Link className="btn btn-base border-radius-5" to="/contact">
                        Book a Free Funding Readiness Call
                      </Link>
                      <Link className="btn btn-border-base border-radius-5" to="/apply">
                        Apply
                      </Link>
                      <a
                        className="btn btn-border-base border-radius-5"
                        href="/downloads/evolvelab-fund-jumpstart-overview.pdf"
                      >
                        Download Overview
                      </a>
                    </div> */}

                    {/* WHO IT'S FOR */}
                    <h4>Who Fund Jumpstart Is For</h4>
                    <p>Fund Jumpstart is built for:</p>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {forWho.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: '#50af9b' }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p>If you want structure, confidence, and execution clarity, this is for you.</p>
                    {/* <Link className="btn btn-base-color border-radius-5 d-flex align-items-center mb-2" to="/apply">
                      Check If You Qualify
                    </Link> */}

                    {/* PROBLEM */}
                    <h4>The Problem We Solve</h4>
                    <p>Most founders fail to raise capital not because the idea is bad, but because:</p>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {problem.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: '#50af9b' }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p><b>Fund Jumpstart replaces chaos with a plan.</b></p>
                    {/* <a className="btn btn-base-color border-radius-5  align-items-center" href="#how-it-works">
                      See How the Program Works
                    </a> */}

                    {/* WHAT YOU GET */}
                    <h4>What You Get in 30 Days</h4>
                    <p>This is not theory. This is hands-on execution.</p>
                    <p><b>You Receive:</b></p>

                    <div className="row">
                      <div className="col-md-6">
                        <ul className="single-list-inner style-check style-check mb-3">
                          {deliverablesLeft.map((x) => (
                            <li key={x}>
                              <FaCheckCircle style={{ color: '#50af9b' }} /> {x}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="single-list-inner style-check style-check mb-3">
                          {deliverablesRight.map((x) => (
                            <li key={x}>
                              <FaCheckCircle style={{ color: '#50af9b' }} /> {x}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* <div className="d-flex flex-wrap gap-2 mb-5">
                      <a className="btn btn-border-base border-radius-5" href="/downloads/sample-funding-roadmap.pdf">
                        Download a Sample Funding Roadmap
                      </a>
                      <Link className="btn btn-base border-radius-5" to="/apply">
                        Apply for Jumpstart
                      </Link>
                    </div> */}

                    {/* HOW IT WORKS */}
                    <h4 id="how-it-works">How Fund Jumpstart Works</h4>

                    <h6 className="mt-3">Week 1 – Foundation & Structure</h6>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Discovery & funding goals</li>
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Corporate, cap table & structuring audit</li>
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Grant and investor eligibility assessment</li>
                    </ul>

                    <h6>Week 2 – Strategy & Readiness</h6>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Funding roadmap creation</li>
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Investor readiness gap analysis</li>
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Pitch narrative & assumptions review</li>
                    </ul>

                    <h6>Week 3 – Assets & Targeting</h6>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Curated investor list</li>
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Data room templates</li>
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Grant application starter materials</li>
                    </ul>

                    <h6>Week 4 – Execution Plan</h6>
                    <ul className="single-list-inner style-check style-check mb-4">
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Capital strategy review</li>
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> 90-day funding calendar</li>
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Clear next steps & priorities</li>
                    </ul>

                    <p><b>No fluff. No filler. No wasted motion.</b></p>
                    {/* <Link className="btn btn-base border-radius-5 mb-5" to="/apply">
                      See the Full 30-Day Plan
                    </Link> */}

                    {/* WHY CHOOSE */}
                    <h4>Why Founders Choose Evolvelab</h4>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {whyChoose.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: '#50af9b' }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p>We act as your fractional funding CXO, not a one-off advisor.</p>
                    {/* <Link className="btn btn-base border-radius-5 mb-5" to="/contact">
                      Speak With a Funding Strategist
                    </Link> */}

                    {/* PRICING */}
                    <h4 id="pricing">Pricing (Simple & Transparent)</h4>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Fixed Fee: <b>CAD $2,500</b></li>
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Timeline: <b>30 days</b></li>
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Equity Taken: <b>None</b></li>
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Success Fees: <b>None</b></li>
                      <li><FaCheckCircle style={{ color: '#50af9b' }} /> Hidden Costs: <b>None</b></li>
                    </ul>
                    <p><b>You pay for clarity — not promises.</b></p>
                    {/* <Link className="btn btn-base border-radius-5 mb-5" to="/apply">
                      Get Started This Month
                    </Link> */}

                    {/* NOT INCLUDED */}
                    <h4>What This Is Not</h4>
                    <p>To stay focused, Fund Jumpstart does not include:</p>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {notIncluded.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: '#50af9b' }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p>(These can be added later — once the strategy is clear.)</p>
                    {/* <Link className="btn btn-base border-radius-5 mb-5" to="/contact">
                      Clarify Scope on a Free Call
                    </Link> */}

                    {/* OUTCOME */}
                    <h4>The Outcome</h4>
                    <p>After Fund Jumpstart, you will have:</p>
                    <ul className="single-list-inner style-check style-check mb-4">
                      {afterProgram.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: '#50af9b' }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p><b>You stop guessing. You start executing.</b></p>
                    {/* <Link className="btn btn-base border-radius-5 mb-5" to="/apply">
                      Apply for Evolvelab Fund Jumpstart
                    </Link> */}

                    {/* FAQ */}
                    <h4>Get touch have any question ?</h4>
                    <p>Quick answers before you start your 30-day Jumpstart.</p>

                    <div
                      className="accordion accordion-inner accordion-icon-left mt-3 mb-4"
                      id="accordionExample"
                    >
                      <div className="accordion-item">
                        <h3 className="accordion-header" id="headingOne">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="true"
                            aria-controls="collapseOne"
                          >
                            What services do you offer?
                          </button>
                        </h3>
                        <div
                          id="collapseOne"
                          className="accordion-collapse collapse show"
                          aria-labelledby="headingOne"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            A 30-day Funding-as-a-Service engagement: roadmap, eligibility, investor list, readiness gap analysis,
                            pitch optimization notes, data room templates, and a 90-day funding calendar.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h3 className="accordion-header" id="headingTwo">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            How long does it take for you to complete a project?
                          </button>
                        </h3>
                        <div
                          id="collapseTwo"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            Fund Jumpstart runs for 30 days. You’ll have a clear plan and usable assets within that window.
                          </div>
                        </div>
                      </div>

                      <div className="accordion-item">
                        <h3 className="accordion-header" id="headingThree">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThree"
                            aria-expanded="false"
                            aria-controls="collapseThree"
                          >
                            How much does it cost to work with your agency?
                          </button>
                        </h3>
                        <div
                          id="collapseThree"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingThree"
                          data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            Fixed fee: CAD $2,500 for 30 days. No equity, no success fees, no hidden costs.
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* “Our Best it company” (kept to match your template section) */}
                    <h4>Our Best it company</h4>
                    <p>Why founders choose Evolvelab for fundability-first execution.</p>
                    <div className="row">
                      <div className="col-md-6">
                        <ul className="single-list-inner style-check style-check mb-3">
                          <li><FaCheckCircle style={{ color: '#50af9b' }} /> Fundability-first approach</li>
                          <li><FaCheckCircle style={{ color: '#50af9b' }} /> Grants + equity strategy</li>
                          <li><FaCheckCircle style={{ color: '#50af9b' }} /> Structure fixed before pitching</li>
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="single-list-inner style-check style-check mb-3">
                          <li><FaCheckCircle style={{ color: '#50af9b' }} /> Reduced dilution & wasted effort</li>
                          <li><FaCheckCircle style={{ color: '#50af9b' }} /> Clarity before execution</li>
                          <li><FaCheckCircle style={{ color: '#50af9b' }} /> Fractional Funding CXO mindset</li>
                        </ul>
                      </div>
                    </div>

                    {/* FINAL CONVERSION */}
                    <h4>Ready to Stop Guessing and Start Raising?</h4>
                    <p>If you want clarity before committing time, money, or dilution — Fund Jumpstart is your first step.</p>

                    <div className="d-flex flex-wrap gap-2 mt-3">
                      <button
                        type="button"
                        className="btn btn-base-color border-radius-5"
                        style={{ backgroundColor: '#50af9b', borderColor: '#50af9b' }}
                        onClick={() => setShowMeetings((s) => !s)}
                      >
                        📅 Book a Free Funding Readiness Call
                      </button>
                      {/* <a className="btn btn-border-base border-radius-5" href="/downloads/evolvelab-fund-jumpstart-overview.pdf">
                        📄 Download the Program Overview
                      </a> */}
                      <Link className="btn btn-black border-radius-5" to="/apply">
                        🚀 Apply for Fund Jumpstart
                      </Link>
                    </div>

                    {/* Render embed container when toggled on */}
                    {showMeetings && (
                      <div className="mt-4">
                        <div
                          className="meetings-iframe-container"
                          data-src="https://meetings.hubspot.com/mike-qureshi?embed=true"
                        ></div>
                      </div>
                    )}

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* ===================== Service Details Area End ===================== */}
    </>
  );
  
};

export default JumpStartArea;
